import styled from '@emotion/styled'

export const StyledImageExteriorSide = styled.div`
display:flex;
flex-direction:column;
align-items:center;
  background: url('${p => p.url}');
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: ${p => p.offset_y || '-50px'};
  background-position-x: ${p => p.offset_x};
  width: ${p => (p.isDesktop ? 600 : 350)}px;
  height: ${p => (p.isDesktop ? 300 : 200)}px;
`
export const StyledImageExteriorFront = styled.div`
  background: url('${p => p.url}');
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: ${p => p.offset_y || '-50px'};
  background-position-x: ${p => p.offset_x || '-37px'};
  width: ${p => (p.isDesktop ? 600 : 350)}px;
  height: ${p => (p.isDesktop ? 380 : 300)}px;
`
export const StyledImageTop = styled.div`
  background: url('${p => p.url}');
  background-repeat: no-repeat;
  background-position-y: ${p => p.offset_y || '-30px'};
  background-position-x: ${p => p.offset_x};
  background-size: cover;
  width: ${p => (p.isDesktop ? 450 : 400)}px;
  height: ${p => (p.isDesktop ? 550 : 500)}px;
`
export const StyledImageTopLong = styled.div`
  background: url('${p => p.url}');
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: ${p => p.offset_y || '0px'};
  background-position-x: ${p => p.offset_x || '0px'};
  width: ${p => (p.isDesktop ? 400 : 400)}px;
  height: ${p => (p.isDesktop ? 600 : 600)}px;
`
export const StyledImageTopShort = styled.div`
  background: url('${p => p.url}');
  background-repeat: no-repeat;
  background-size: cover;
  width: ${p => (p.isDesktop ? 400 : 300)}px;
  height: ${p => (p.isDesktop ? 400 : 300)}px;
`
export const StyledTagTopRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: ${p => (p.reverse ? 'row-reverse' : 'row')};
  justify-content: ${p => (p.isDesktop ? 'space-around' : 'space-between')};
  top: ${p => p.top};
  width: ${p => p.width || '100%'};
  div:first-of-type,
  div:last-child {
    top: -20px;
  }
`
export const StyledTagBottomRow = styled.div`
  position: relative;
  display: flex;
  padding-right: ${p => p.paddingRight || (!p.reverse && (p.isDesktop ? '30px' : '20px'))};
  padding-left: ${p => p.paddingLeft || (p.reverse && (p.isDesktop ? '30px' : '20px'))};
  flex-direction: ${p => (p.reverse ? 'row-reverse' : 'row')};
  justify-content: ${p => (p.isDesktop ? 'space-around' : 'space-between')};
  top: ${p => p.top};
  width: ${p => p.width || '100%'};
  div:first-child,
  div:last-child {
    top: ${p => p.isDesktop && '-10px'};
  }
`
export const StyledTagColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  top: ${p => p.top};
  height: ${p => p.height};
`
export const PillLabel = styled.div`
  border-width: 1px;
  border-radius: 10px;
  border-color: #ccc;
  background: #fff;
  padding: 0 8px;
  font-weight: 700;
  font-size: 12px;
  border-style: solid;
  width: fit-content;
  cursor: pointer;
`
export const StyledIconLabelVertical = styled.div`
  position: relative;
  width: fit-content;
  left: ${p => p.left};
  top: ${p => p.top};
  display: flex;
  flex-direction: ${p => (p.reverse ? 'column-reverse' : 'column')};
  align-items: center;
  .selected {
    cursor: pointer;
    width: 20px;
    > path {
      fill: green;
    }
  }
  .deselected {
    cursor: pointer;
    width: 20px;
    > path {
      fill: #0057b5;
    }
  }
`
export const StyledIconLabelHorizontal = styled.div`
  border-width: 1px;
  border-radius: 12px;
  border-color: #ccc;
  background: #fff;
  padding: 1px;
  font-weight: 700;
  font-size: 12px;
  border-style: solid;
  width: fit-content;
  cursor: pointer;
  position: relative;
  width: fit-content;
  left: ${p => p.left};
  top: ${p => p.top};
  display: flex;
  flex-direction: ${p => (p.reverse ? 'row-reverse' : 'row')};
  align-items: center;
  .selected {
    cursor: pointer;
    width: 20px;
    > path {
      fill: green;
    }
  }
  .deselected {
    cursor: pointer;
    width: 20px;
    > path {
      fill: #0057b5;
    }
  }
  > div {
    padding: 0 4px;
  }
`
export const SvgBg = styled.div`
  width: 24px;
  height: 24px;
  background-color: #fff;
  border-color: #ccc;
  border-radius: 50%;
  border-width: 1px;
  border-style: solid;
  padding: 1px;
`
export const StyledTagDualIconLabel = styled.div`
  position: relative;
  display: flex;
  flex-direction: ${p => (p.reverse ? 'row-reverse' : 'row')};
  justify-content: space-between;
  ${p =>
    p.staggered &&
    `div:nth-of-type(2) {
    position: relative;
    top: ${p.reverse ? '10px' : '-10px'};
  };`}
  width: ${p => p.width};
  left: ${p => p.left};
  top: ${p => p.top};
  .selected {
    cursor: pointer;
    width: 20px;
    > path {
      fill: green;
    }
  }
  .deselected {
    cursor: pointer;
    width: 20px;
    > path {
      fill: #0057b5;
    }
  }
`
export const StyledWindshieldRow = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  top: ${p => p.top};
  width: ${p => p.width};
`
